import Api from 'embed/services/Api'
import Session from 'embed/services/Session'
import { ActionTypeKeys } from 'embed/actions'

import { Tracker } from 'ui/multi-product/services/Tracker'
// @TODO: revist to test middlware when making changes when removing unused variables
export const trackingMiddleware = (tracker: Tracker, parent) => (store) => (next) => (action) => {
  if (action.trackingKey !== undefined) {
    tracker.trackEvent({
      action: action.trackingKey,
      data: action.trackingData || {},
      timestamp: action.timestamp || new Date(),
    })
  }

  if (action.publishKey !== undefined) {
    action.leadUuid = Session.getLeadUuid()
    action.sessionUuid = Session.sessionUuid
    parent.publishMessage(action.publishKey, action)
  }

  if (action.type === ActionTypeKeys.SESSION_INITIALIZED) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    Api.post(`/uiEvent/sessionInits`, { sessionUuid: action.sessionUuid })
  }

  if (action.meta?.trackingKey !== undefined) {
    tracker.trackEvent({
      action: action.meta.trackingKey,
      data: action.meta.trackingData,
      timestamp: action.meta.timestamp,
    })
  }

  return next(action)
}
